function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "0",
  width: "0",
  display: "block"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logoPath",
  transform: "scale(.61)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 81.372v-69.75L11.621 0h13.94v18.604H46.51l11.62 11.62v39.527L46.51 81.372H32.544V44.165h-6.982v25.586L13.94 81.372H0zM74.414 81.372L62.793 69.751V39.526l20.923-20.923h25.586l11.621 11.622v20.922l-4.663 4.663h4.663v13.941l-11.621 11.621H74.414zM125.586 81.372V30.225l11.621-11.622h27.905l9.302 9.302v13.94l-11.621 11.622h-11.646V69.75l-11.621 11.621h-13.94zM190.723 81.372l-11.621-11.621V39.526l20.922-20.923h25.586l11.621 11.622v20.922l-4.663 4.663h4.663v13.941L225.61 81.372h-34.887z",
  fill: "#fff"
})))));